import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getBedAllotments } from 'app/entities/bed-allotment/bed-allotment.reducer';
import { getEntities as getWardCharges } from 'app/entities/ward-charges/ward-charges.reducer';
import { getEntities as getHospitalPatientCategoryAttributes } from 'app/entities/hospital-patient-category-attributes/hospital-patient-category-attributes.reducer';
import { createEntity, getEntity, reset, updateEntity } from './bed-allotment-charge.reducer';

export const BedAllotmentChargeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const bedAllotments = useAppSelector(state => state.bedAllotment.entities);
  const wardCharges = useAppSelector(state => state.wardCharges.entities);
  const hospitalPatientCategoryAttributes = useAppSelector(state => state.hospitalPatientCategoryAttributes.entities);
  const bedAllotmentChargeEntity = useAppSelector(state => state.bedAllotmentCharge.entity);
  const loading = useAppSelector(state => state.bedAllotmentCharge.loading);
  const updating = useAppSelector(state => state.bedAllotmentCharge.updating);
  const updateSuccess = useAppSelector(state => state.bedAllotmentCharge.updateSuccess);

  const handleClose = () => {
    navigate(`/bed-allotment-charge${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getBedAllotments({}));
    dispatch(getWardCharges({}));
    dispatch(getHospitalPatientCategoryAttributes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.fromDate !== undefined && typeof values.fromDate !== 'number') {
      values.fromDate = Number(values.fromDate);
    }
    if (values.toDate !== undefined && typeof values.toDate !== 'number') {
      values.toDate = Number(values.toDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }

    const entity = {
      ...bedAllotmentChargeEntity,
      ...values,
      allotment: bedAllotments.find(it => it.id.toString() === values.allotment?.toString()),
      appliedCharge: wardCharges.find(it => it.id.toString() === values.appliedCharge?.toString()),
      multiplierEntry: hospitalPatientCategoryAttributes.find(it => it.id.toString() === values.multiplierEntry?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...bedAllotmentChargeEntity,
          allotment: bedAllotmentChargeEntity?.allotment?.id,
          appliedCharge: bedAllotmentChargeEntity?.appliedCharge?.id,
          multiplierEntry: bedAllotmentChargeEntity?.multiplierEntry?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.bedAllotmentCharge.home.createOrEditLabel" data-cy="BedAllotmentChargeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.bedAllotmentCharge.home.createOrEditLabel">
              Create or edit a BedAllotmentCharge
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="bed-allotment-charge-id"
                  label={translate('tinyMedicRestApp.bedAllotmentCharge.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.bedAllotmentCharge.fromDate')}
                id="bed-allotment-charge-fromDate"
                name="fromDate"
                data-cy="fromDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bedAllotmentCharge.toDate')}
                id="bed-allotment-charge-toDate"
                name="toDate"
                data-cy="toDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bedAllotmentCharge.active')}
                id="bed-allotment-charge-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bedAllotmentCharge.cursor')}
                id="bed-allotment-charge-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bedAllotmentCharge.lastUpdated')}
                id="bed-allotment-charge-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bedAllotmentCharge.microSec')}
                id="bed-allotment-charge-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bedAllotmentCharge.timestampEntry')}
                id="bed-allotment-charge-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bedAllotmentCharge.discount')}
                id="bed-allotment-charge-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                id="bed-allotment-charge-allotment"
                name="allotment"
                data-cy="allotment"
                label={translate('tinyMedicRestApp.bedAllotmentCharge.allotment')}
                type="select"
              >
                <option value="" key="0" />
                {bedAllotments
                  ? bedAllotments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="bed-allotment-charge-appliedCharge"
                name="appliedCharge"
                data-cy="appliedCharge"
                label={translate('tinyMedicRestApp.bedAllotmentCharge.appliedCharge')}
                type="select"
              >
                <option value="" key="0" />
                {wardCharges
                  ? wardCharges.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="bed-allotment-charge-multiplierEntry"
                name="multiplierEntry"
                data-cy="multiplierEntry"
                label={translate('tinyMedicRestApp.bedAllotmentCharge.multiplierEntry')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalPatientCategoryAttributes
                  ? hospitalPatientCategoryAttributes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/bed-allotment-charge" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BedAllotmentChargeUpdate;
